export class FinanceiroModel {
    coligada?:string
    origem?:string
    valor?:string
    valor_chart?:number
    perc_valor?:string
    parcelas?:string
    perc_parcelas?:string    

    filtro_data_inicial:Date
    filtro_data_final:Date
}